// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collapse-handler[data-v-89ab01ac]{cursor:pointer}.el-icon-check_installed[data-v-89ab01ac]{color:green}", ""]);
// Exports
module.exports = exports;
